var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.004,
    viewBox: "0 0 24 24.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messages",
    d: "M13,0H5A5.006,5.006,0,0,0,0,5V17.85a2.149,2.149,0,0,0,3.34,1.789L7.3,17H13a5.006,5.006,0,0,0,5-5V5A5.006,5.006,0,0,0,13,0ZM24,9V21.85a2.148,2.148,0,0,1-3.339,1.79L16.7,21H11a4.973,4.973,0,0,1-3.661-1.62L7.908,19H13a7.009,7.009,0,0,0,7-7V5a7.128,7.128,0,0,0-.065-.906A5,5,0,0,1,24,9Z",
    transform: "translate(0 0.004)",
    fill: "#004fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.73f11e2838c29d45f8630ec8e7b6cb1f.svg";
export { ForwardRef as ReactComponent };